import { IForgotService } from "@/services/forgot/IForgotService";
import { ForgotService } from "@/services/forgot/ForgotService";
import { Container } from "inversify";
import { IoCTypes } from "./IoCTypes";

export function bindForgotService(container:Container) {
    container.bind<IForgotService>(IoCTypes.ForgotService).to(ForgotService)
}